import { AxiosError } from "axios";
import AjexPortalService from "./api";
import { getNotificationStyle } from "../common/notification";

const commonServiceURL: string | undefined = process.env.REACT_APP_TMS_COMMON_SERVICE;
const aoneIntegrationServiceURL: string | undefined = process.env.REACT_APP_TMS_AONE_INTEGRATION_SERVICE;

export interface ICreateHandoverSheet {
    waybillNumber: string[];
    deliveryDriverId: number;
    stationId: number;
    aoneHubId: number;
}

export interface ITmsAoneWaybillMapping {
    waybillNo: string;
    aoneWaybillNo: string;
}

export interface ICreateHandoverSheetAone {
    tmsAoneWaybillMappings: ITmsAoneWaybillMapping[];
    deliveryDriverId: number;
    stationId: number;
    aoneHubId: number;
    handoverScanByEmpId?: number;
}

export interface IHandoverSheetPaginatedParams {
    page: number;
    size: number;
    waybillNo?: string;
    startDate?: string;
    endDate?: string;
    aoneWaybillNo?: string;
    stationId?: number;
    handoverSheetCode?: string;
    handoverSheetStatus?: boolean;
}

export const GetHandoverSheetPaginatedService = async (params: IHandoverSheetPaginatedParams) => {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append("page", String(params.page));
        queryParams.append("size", String(params.size));
        if (params.waybillNo) queryParams.append("waybillNo", params.waybillNo);
        if (params.startDate) queryParams.append("startDate", params.startDate);
        if (params.endDate) queryParams.append("endDate", params.endDate);
        if (params.aoneWaybillNo) queryParams.append("aoneWaybillNo", params.aoneWaybillNo);
        if (params.stationId !== undefined) queryParams.append("stationId", String(params.stationId));
        if (params.handoverSheetCode) queryParams.append("handoverSheetCode", params.handoverSheetCode);
        if (params.handoverSheetStatus !== undefined) queryParams.append("handoverSheetStatus", String(params.handoverSheetStatus));

        return await AjexPortalService.get(`${commonServiceURL}handover-sheet/paginated?${queryParams.toString()}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetCreateHandoverSheetWaybillsService = async (stationId: string) => {
    try {
        // 1/handover-sheet/aone-waybills?stationId=1'
        return await AjexPortalService.get(`${commonServiceURL}handover-sheet/aone-waybills?stationId=${stationId}`)
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const CreateHandoverSheetAoneService = async (payload: ICreateHandoverSheetAone) => {
    try {
        return await AjexPortalService.post(`${commonServiceURL}handover-sheet`, payload);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const GetHandoverSheetByIdService = async (id: number | string) => {
    try {
        return await AjexPortalService.get(`${commonServiceURL}handover-sheet/details/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}



export const UpdateHandoverSheetService = async (id: number | string, payload: ICreateHandoverSheetAone) => {
    try {
        return await AjexPortalService.put(`${commonServiceURL}handover-sheet/${id}`, payload);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const CancelHandoverSheetService = async (id: number | string) => {
    try {
        return await AjexPortalService.patch(`${commonServiceURL}handover-sheet/cancel/${id}`, {});
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export interface ICancelHandoverWaybills {
    waybills: string[];
}

export const CancelHandoverWaybillsService = async (payload: ICancelHandoverWaybills) => {
    try {
        return await AjexPortalService.patch(`${commonServiceURL}handover-sheet/cancel/waybills`, payload);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export interface IAoneSimplePaginatedParams {
    page: number;
    size: number;
    waybillNo?: string;
    stationId?: number;
    startDate?: string;
    endDate?: string;
    customerId?: number;
    customerSubAccountId?: number;
}

export interface IAoneIntegrationPaginatedParams extends IAoneSimplePaginatedParams {
    status?: string;
}

const buildAoneQueryParams = (params: IAoneSimplePaginatedParams): URLSearchParams => {
    const qp = new URLSearchParams();
    qp.append("page", String(params.page));
    qp.append("size", String(params.size));
    if (params.waybillNo) qp.append("waybillNo", params.waybillNo);
    if (params.stationId !== undefined) qp.append("stationId", String(params.stationId));
    if (params.customerId !== undefined) qp.append("customerId", String(params.customerId));
    if (params.customerSubAccountId !== undefined) qp.append("customerId", String(params.customerSubAccountId));
    if (params.startDate) qp.append("startDate", params.startDate);
    if (params.endDate) qp.append("endDate", params.endDate);
    return qp;
};

export const GetAoneIntegrationWaybillPaginatedService = async (params: IAoneIntegrationPaginatedParams) => {
    const qp = buildAoneQueryParams(params);
    if (params.status) qp.append("status", params.status);
    return await AjexPortalService.get(`${aoneIntegrationServiceURL}aims/aone/paginated?${qp.toString()}`);
};

export const GetAoneEligibleWaybillPaginatedService = async (params: IAoneSimplePaginatedParams) => {
    try {
        const qp = buildAoneQueryParams(params);
        return await AjexPortalService.get(`${aoneIntegrationServiceURL}aims/aone/eligible/waybills/paginated?${qp.toString()}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAoneFailedWaybillPaginatedService = async (params: IAoneSimplePaginatedParams) => {
    try {
        const qp = buildAoneQueryParams(params);
        return await AjexPortalService.get(`${aoneIntegrationServiceURL}aims/aone/failed/waybills/paginated?${qp.toString()}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const CreateAoneWaybillService = async (payload: { waybills: string[] }) => {
    try {
        return await AjexPortalService.post(`${aoneIntegrationServiceURL}aims/aone/create`, payload);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetAoneHubsByStationService = async (stationId: number | string) => {
    try {
        return await AjexPortalService.get(`${commonServiceURL}handover-sheet/aone-hubs-by-station/${stationId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const PrintHandoverSheetService = async (id: number | string) => {
    try {
        return await AjexPortalService.get(`${commonServiceURL}print/handover-sheet-print/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const getAonePodListService = async (filteredData: object) => {
    try {
        return await AjexPortalService.post(`${commonServiceURL}pod-details/aone/pod-list`, filteredData);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
}

export const getHandoverAssignEmployeesService = async (req, isDriver = true) => {
    try {
        return await AjexPortalService.post(`employee/find-employees-by-positions-id?isDriver=${isDriver}`, req);
    } catch (error: unknown) {
        const err = error as AxiosError
        getNotificationStyle(err?.response);

        return err?.response;
    }
}

